export default __webpack_public_path__ + "static/media/Vientos de Cordoba.12f7373e.jpg";